/*
 * @Author: 张天昊
 * @Date: 2024-06-04 15:59:46
 * @LastEditTime: 2024-06-04 16:00:24
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/pages/itineraryUniversal/composables/useTabsHeight.js
 */
import { inject } from 'vue';
export function useTabsHeight() {
  const tabsInst = inject('tabsInst');
  function getTabsNavHeight() {
    if (tabsInst.value) {
      const tabsEl = tabsInst.value.$el;
      const tabsNavContainerEl = tabsEl.querySelector(':first-child');
      if (tabsNavContainerEl) {
        const height = tabsNavContainerEl.getBoundingClientRect().height;
        return height;
      }
      return 0;
    }
    return 0;
  }

  return {
    getTabsNavHeight
  };
}
